import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { Home } from './pages/home/Home';
import Footer from './utility/footer/Footer';
import { Project } from './pages/project/Project';
import { DetailedProjectPage } from './pages/project/components/DetailedProjectPage';
import { DetailedServicePage } from './pages/service/components/DetailedServicePage';
import { NavBar } from './utility/navBar/Navbar';
import { Service } from './pages/service/Service';
import { About } from './pages/about/About';
import { ContactForm } from './pages/contact_form/ContactForm';
import Quiz from './pages/quiz/Quiz'
import { Blog } from './pages/blog/Blog'
import Dashboard from './pages/admin/dashboard'
import Blogs from './pages/admin/blogs/Blogs';
import Form from './pages/admin/blogs/Form';
import ProtectedRoute from './pages/admin/components/ProtectedRoute'
import Login from './pages/users/Login';
import 'animate.css';
import '../src/assets/css/dashboard.css'
function NotFound() {
  return (

    <div className="not-found">
      <NavBar theme='dark' />
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/projects/:projectId" element={<DetailedProjectPage />} />
          <Route path="/services" element={<Service />} />
          <Route path="/service/:serviceId" element={<DetailedServicePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="*" element={<NotFound />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Outlet />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="blog/add" element={<Form />} />
            <Route path="blog/edit/:id" element={<Form />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
